import { Modal, Steps } from "antd";
import moment from "moment";
import React from "react";
import Loading from "../Main/Loading";

function Tracer({ props }) {
  const { isModal, loading, onCancel, dataTracking } = props;
  const { Step } = Steps;

  return (
    <Modal
      title={null}
      visible={isModal}
      onOk={null}
      onCancel={null}
      footer={null}
      closable={false}
      keyboard={false}
      width={400}
    >
      <div>
        <div className="mb-3 flex items-center justify-between">
          <p className="header-title-bold colors-blue text-2xl font-bold">
            Detail Tracking
          </p>
          <p
            onClick={onCancel}
            className="header-content colors-gray text-lg font-semibold cursor-pointer"
          >
            Tutup
          </p>
        </div>

        {/* Content Section */}
        {loading ? (
          <Loading />
        ) : (
          <div className="mt-8 mb-4">
            <Steps
              progressDot
              current={dataTracking.length - 1}
              direction="vertical"
            >
              {dataTracking.map((it, index) => (
                <Step
                  key={index}
                  className="header-content "
                  title={it.keterangan}
                  description={moment(it.datetime).format(
                    "DD MM YYYY HH:mm:ss"
                  )}
                />
              ))}
            </Steps>
          </div>
        )}
      </div>
    </Modal>
  );
}

export default Tracer;
